import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {CrossBrandsItemsAboveSearchBox} from "./boxes/cross-brands-items-above-search.box";
import {CyClass} from '../../../../common/cy-classes';
import {MenuItemKey} from "../../../services/configurations/config-data-sections/generated-config-const";
import classNames from "classnames";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {withServices} from "../../../react-hooks/with-services";

export interface SideMenuItemsAboveSearchProps extends ComponentServicesPick<'sideMenu'>{
  menuItemKeys: MenuItemKey[];
  className?: string;
}

@observer
class ComponentBody extends OrbitComponent<SideMenuItemsAboveSearchProps> {
    
    private menuItemKeyIsCrossBrand(k: MenuItemKey): k is "sportCrossBrandMenuItem" | "pokerCrossBrandMenuItem" {
        return k === "sportCrossBrandMenuItem" || k === "pokerCrossBrandMenuItem";
    }

    render() {
        const menuItems = this.props.menuItemKeys.filter(k => {
            return this.menuItemKeyIsCrossBrand(k);
        }).map(key => this.props.sideMenu.getCrossBrandAboveSearchItemRenderer(key))
        .filter(menuItem => menuItem.display);

        if (menuItems.length === 0) {
            return null;
        }

        return (
            <CrossBrandsItemsAboveSearchBox className={classNames(CyClass('cy-menu-links-group'), CyClass('cy-menu-links-cross-brands-group'))} totalItems={menuItems.length}>
                {
                    menuItems.map(menuItem => (
                        <React.Fragment key={menuItem.key}>
                            {menuItem.renderMenuItem()}
                        </React.Fragment>)
                    )
                }
            </CrossBrandsItemsAboveSearchBox>
        )
    }
}

export const CrossBrandsItemsAboveSearch = withServices(ComponentBody,  ['sideMenu'])